<template>
    <div v-if="total > listN" id="pagination-component">
        <ul>
            <li>
                <a href="#" @click="first" title="Primeira página" style="background: none;padding: 0;">
                    <img alt="Primeira página" src="../../assets/img/seta_1.webp" style="transform: rotate(90deg)">
                    <img alt="Primeira página" src="../../assets/img/seta_1.webp" style="transform: rotate(90deg);margin-left:-8px;">
                </a>
            </li>
            <li><a href="#" @click="prev" title="Página anterior" style="background: none;;padding: 0;"><img alt="Página anterior" src="../../assets/img/seta_1.webp" style="transform: rotate(90deg);"></a></li>
            <li v-for="(o, key) in pages" :key="'page_' + key + '_' + o.o"><a href="#" v-bind:class="{ active: o.active }" @click="pageHandler">{{ o.o }}</a></li>
            <li><a href="#" @click="next" title="Próxima página" style="background: none;;padding: 0;"><img alt="Próxima página" src="../../assets/img/seta_1.webp" style="transform: rotate(270deg)"></a></li>
            <li>
                <a href="#" @click="last" title="Última página" style="background: none;padding: 0;">
                    <img alt="Última página" src="../../assets/img/seta_1.webp" style="transform: rotate(270deg)">
                    <img alt="Última página" src="../../assets/img/seta_1.webp" style="transform: rotate(270deg);margin-left:-8px;">
                </a>
            </li>
        </ul>
        <!-- <Loading v-if="loading"></Loading> -->
    </div>
</template>

<script>
let emitter = require('tiny-emitter/instance');
export default
{
    props:
    {
        chunk: { type: Number, default: 7 },
        total: { type: [Number, String], default: 0 }
    },
    data()
    {
        return {
            listN    : this.chunk ? this.chunk : 7,
            pagMax    : 2,
            pages     : null,
            p         : 0,
            pFinal    : 0
        }
    },
    components: { },
    methods:
    {
        algorithm(current, { min = 1, length = this.pagMax} = {})
        {
            if (length > this.pFinal) length = this.pFinal;
            let start = current - Math.floor(length / 2);
            start = Math.max(start, min);
            start = Math.min(start, min + this.pFinal - length);
            return Array.from({ length: length }, (el, i) => start + i);
        },
        processing()
        {
            this.pages = [];
            let ar = this.algorithm(this.p + 1);
            for (let n = 0; n < ar.length; n++)
            {
                this.pages.push({ active:(ar[n] == (this.p + 1)), o:ar[n] });
            }
            // history.pushState({ page: this.p }, "", "?page=" + this.p);
            // this.$bus.emit('paginationHandler', { page: this.p });
            emitter.emit('Chat::open::group::users_list', { page: this.p });
        },
        pageHandler(e)
        {
            this.p = Number(e.currentTarget.innerHTML) - 1;
            this.processing();

            e.preventDefault();
        },
        prev(e)
        {
            if (this.p > 0)
            {
                this.p--;
                this.processing();
            }
            e.preventDefault();
        },
        next(e)
        {
            if (this.p < (this.pFinal - 1))
            {
                this.p++;
                this.processing();
            }
            e.preventDefault();
        },
        first(e)
        {
            if (this.p > 0)
            {
                this.p = 0;
                this.processing();
            }
            e.preventDefault();
        },
        last(e)
        {
            if (this.p < (this.pFinal - 1))
            {
                this.p = this.pFinal - 1;
                this.processing();
            }
            e.preventDefault();
        },

        eventHandler(obj)
        {
            this.init    = false;
            this.pFinal = Math.ceil(obj.total / this.listN);
            this.total   = obj.total;


            
            this.processing();
        },

        
    },
    mounted()
    {
        this.p = 0;
        this.pFinal = Math.ceil(this.total / this.listN);

        console.log('#### Pagination => ', this.p, this.pFinal, this.total);
        this.processing();
    }
}
</script>
<style scoped>
    #pagination-component
    {
        background-color: transparent;
        text-align: center;
        padding: 20px 0;
    }
    #pagination-component > ul > li
    {
        display: inline-block;
        list-style: none;
        padding: 0 6px;
        vertical-align: middle;
    }
    #pagination-component > ul > li > a
    {
        background: #F1F1F1;
        border-radius: 7px;
        box-sizing: border-box;
        display: inline-block;
        padding: 4px 10px;
        text-decoration: none;
        vertical-align: top;
    }
    #pagination-component .active
    {
        background-color: #23A0CE;
        color: white;
        font-size: 16px;
        font-weight: bold;
    }
    #pagination-component img
    {
        filter: brightness(0) saturate(100%) invert(47%) sepia(0%) saturate(7500%) hue-rotate(52deg) brightness(95%) contrast(94%);
    }
</style>
